var colors = {
    brandy_snifter: '#8a3632',
    aqua_sky: '#7fcdcd',
    aqua_green: '#62afb4',
    army_green: '#52492e',
    beige: '#F7ECCE',
    black: '#000',
    bright_orange: '#ff7420',
    brown: '#563d2d',
    burgundy: '#800020',
    cinnamon: '#9B4722',
    dark_green: '#1F3D0C',
    dark_slate: '#46515A',
    deep_red_brown: '#493035',
    deep_taupe: '#847366',
    desert_taupe: '#D1BCAA',
    grey: '#939597',
    indigo: '#313f4a',
    ivory: '#E4DAC9',
    light_blue: '#8cb3eb',
    macchiato: '#AC8266',
    maroon: '#7e3f3a',
    midnight_green: '#1e4621',
    navy_blue: '#202a44',
    nude: '#cfb095',
    ocean_blue: '#0b5675',
    olive_branch: '#6a6a45',
    olivine: '#666B54',
    olive: '#76632d',
    peach: '#F3D0B6',
    sapphire_blue: '#013079',
    space_grey: '#262626',
    sparkling_grape: '#ae5ead',
    strawberry_pink: '#f87b90',
    tan: '#C9A48E',
    teal: '#075055',
    toffee: '#6B5043',
    viva_magenta: '#d84151',
    volcanic_ash: '#484849',
    white: '#fff',

    gunsmoke: '#878984',
    silver: '#C0C0C0',

    cool_grey: '#C1aFa3',
    pink_marshmallow: '#F8E0E7',
    sifting_sand: '#E3BC9A',
    desert_sun: '#f47c3c',
    sample: '#fff',
    grey_marl: '#BFC1C3',

    bronze: '#be8860',
    emerald: '#bdb460',
    gold: '#dfbf65',
};

$.fn.truncate = function(options) {

    var defaults = {
        length: 300,
        minTrail: 20,
        moreText: "more",
        lessText: "less",
        ellipsisText: "..."
    };

    var options = $.extend(defaults, options);

    return this.each(function() {
        obj = $(this);
        // alert(options.minTrail);
        var body = obj.html();
        if (body.length > options.length + options.minTrail) {
            var splitLocation = body.indexOf(' ', options.length);
            if (splitLocation != -1) {
                // truncate tip
                var splitLocation = body.indexOf(' ', options.length);
                var str1 = body.substring(0, splitLocation);
                var str2 = body.substring(splitLocation, body.length - 1);
                obj.html(str1 + '<span class="truncate_ellipsis">' + options.ellipsisText +
                    '</span>' + '<span  class="truncate_more">' + str2 + '</span>');
                obj.find('.truncate_more').css("display", "none");
                // insert more link
                obj.append(
                    '<div class="clearboth">' +
                    '<a href="#" class="truncate_more_link">' + options.moreText + '</a>' +
                    '</div>'
                );
                var moreLink = $('.truncate_more_link', obj);
                var moreContent = $('.truncate_more', obj);
                var ellipsis = $('.truncate_ellipsis', obj);
                moreLink.click(function() {
                    if (moreLink.text() == options.moreText) {
                        moreContent.show();
                        moreLink.text(options.lessText);
                        ellipsis.css("display", "none");
                    } else {
                        moreContent.hide();
                        moreLink.text(options.moreText);
                        ellipsis.css("display", "inline");
                    }
                    return false;
                });
            }
        }
    });
};

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function decodeEntities(encodedString) {
  var textArea = document.createElement('textarea');
  textArea.innerHTML = encodedString;
  return textArea.value;
}

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function pad(str, max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}

function createSwiper(destroy = false) {
  if (destroy) {
    homeBannerSwiper.destroy();
    footerswiper.destroy();
    swiperAutoSlide.destroy();
    points_slider.destroy();
    productSwiper.destroy();
  }
  const homeBannerSwiper = new Swiper('.homeBannerSwiper', {
    direction: 'horizontal',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const swiperAutoSlide = new Swiper('.swiperAutoSlide', {
    direction: 'horizontal',
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const points_slider = new Swiper('.swiper.points_slider', {
    direction: 'horizontal',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const productSwiper = new Swiper('.swiper.productSwiper', {
    direction: 'horizontal',
    loop: true,
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
    },
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true
    // },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
  });
}

function hideLoader() {
  $('body').removeClass('preloader-active');
  $('.preloader').hide();
}

$(function() {
  console.error(window.Shopify.country);
  if ($('.product_shipping_table').length) {
    if ($('.product_shipping_table[data-countrycode="'+window.Shopify.country+'"]').length) {
      $('.product_shipping_table[data-countrycode="'+window.Shopify.country+'"]').show();
    } else {
      $('.product_shipping_table[data-countrycode="REST_OFF_WORLD"]').show();
    }
  }

  setTimeout(function() {
    if ($('#qsc2-gift-wrapping').prop('checked')) {
      $('.ProductAccordion-accordion-gift_packaging_check_box').prop('checked', true);
    } else {
      $('.ProductAccordion-accordion-gift_packaging_check_box').prop('checked', false);
    }
  }, 1000);

  $('.ProductAccordion-accordion-gift_packaging_check_box').on('change', function() {
    $('#qsc2-gift-wrapping').click();
  });

  $(document).on('change', '#qsc2-gift-wrapping', function (e) {
    if ($(this).prop('checked')) {
      $('.ProductAccordion-accordion-gift_packaging_check_box').prop('checked', true);
    } else {
      $('.ProductAccordion-accordion-gift_packaging_check_box').prop('checked', false);
    }
  });

  // Doel-datum in CET
  const targetDate = new Date(2025, 4, 9, 11, 0, 0); // 18 april 2025 12:00 CET

  function updateCountdown() {
    // Huidige tijd
    const now = new Date();

    // CET offset in uren (CET is UTC+1, zonder rekening te houden met zomer-/wintertijd)
    const cetOffset = now.getTimezoneOffset() / 60 + 1;

    // Huidige tijd omgerekend naar CET
    const nowCET = new Date(now.getTime() + cetOffset * 3600 * 1000);

    // Bereken het tijdsverschil
    const timeDiff = targetDate - nowCET;

    if (timeDiff > 0) {
      var days = pad(Math.floor(timeDiff / (1000 * 60 * 60 * 24)), 2);
      var hours = pad(Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 2);
      var minutes = pad(Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)), 2);
      var seconds = pad(Math.floor((timeDiff % (1000 * 60)) / 1000), 2);

      var daysTitle = 'days';
      if (days == 1) {
        var daysTitle = 'day';
      }
      var hoursTitle = 'hours';
      if (hours == 1) {
        var hoursTitle = 'hour';
      }
      var minutesTitle = 'minutes';
      if (minutes == 1) {
        var minutesTitle = 'minute';
      }
      var secondsTitle = 'seconds';
      if (seconds == 1) {
        var secondsTitle = 'second';
      }
      // if (window.Shopify.locale == 'nl') {
      //   var daysTitle = 'dagen';
      //   if (days == 1) {
      //     var daysTitle = 'dag';
      //   }
      //   var hoursTitle = 'uren';
      //   if (hours == 1 || hours == 0) {
      //     var hoursTitle = 'uur';
      //   }
      //   var minutesTitle = 'minuten';
      //   if (minutes == 1) {
      //     var minutesTitle = 'minuut';
      //   }
      //   var secondsTitle = 'seconden';
      //   if (seconds == 1) {
      //     var secondsTitle = 'seconde';
      //   }
      // }

      $('.timer .timer_days').text(days);
      $('.timer_title_days').text(daysTitle);
      $('.timer .timer_hours').text(hours);
      $('.timer_title_hours').text(hoursTitle);
      $('.timer .timer_minutes').text(minutes);
      $('.timer_title_minutes').text(minutesTitle);
      $('.timer .timer_seconds').text(seconds);
      $('.timer_title_seconds').text(secondsTitle);

      $('.menu_blackfriday_addon_timer .menu_blackfriday_addon_timer_hours').text(hours);
      $('.menu_blackfriday_addon_timer .menu_blackfriday_addon_timer_minutes').text(minutes);
      $('.menu_blackfriday_addon_timer .menu_blackfriday_addon_timer_seconds').text(seconds);
    } else {
      $('.timer').text('The time has been reached, please refresh the page!');
    }
  }

  // Update de countdown elke seconde
  setInterval(updateCountdown, 1000);
  // Directe eerste update
  updateCountdown();

  var show_password_field = getUrlParameter('show_password_field');
  if (show_password_field != false && show_password_field != undefined) {
    $('password-modal').show();
  }

  var dev_mode = getUrlParameter('dev_mode');
  if (dev_mode != false && dev_mode != undefined) {
    $('body').addClass('DEV_MODE_ENABLED');
    // $('.custom_product_media_slider').show();
  }

  $('.sticky_add_to_bag_color_select').on('click', function() {
    console.error('sticky_add_to_bag_color_select CLICK');
    console.warn($('.sticky_add_to_bag_color_swatch_product').is(':visible'));

    $('.sticky_add_to_bag_size_select svg').removeClass('rotate180');
    $('.sticky_add_to_bag_product_variant').hide();

    if ($('.sticky_add_to_bag_color_swatch_product').is(':visible')) {
      $('.sticky_add_to_bag').removeClass('sticky_add_to_bag_select_open');
      $('body').removeClass('sticky_add_to_bag_select_open');
      $('.sticky_add_to_bag_color_select svg').removeClass('rotate180');
      $('.sticky_add_to_bag_color_swatch_product').hide();
    } else {
      $('.sticky_add_to_bag').addClass('sticky_add_to_bag_select_open');
      $('body').addClass('sticky_add_to_bag_select_open');
      $('.sticky_add_to_bag_color_select svg').addClass('rotate180');
      $('.sticky_add_to_bag_color_swatch_product').show();

      console.error('sticky_add_to_bag_color_select SHOW');
    }

    console.error('sticky_add_to_bag_color_select END');
  });
  $('.sticky_add_to_bag_size_select').on('click', function() {
    $('.sticky_add_to_bag_color_select svg').removeClass('rotate180');
    $('.sticky_add_to_bag_color_swatch_product').hide();

    if ($('.sticky_add_to_bag_product_variant').is(':visible')) {
      $('.sticky_add_to_bag').removeClass('sticky_add_to_bag_select_open');
      $('body').removeClass('sticky_add_to_bag_select_open');
      $('.sticky_add_to_bag_size_select svg').removeClass('rotate180');
      $('.sticky_add_to_bag_product_variant').hide();
    } else {
      $('.sticky_add_to_bag').addClass('sticky_add_to_bag_select_open');
      $('body').addClass('sticky_add_to_bag_select_open');
      $('.sticky_add_to_bag_size_select svg').addClass('rotate180');
      $('.sticky_add_to_bag_product_variant').show();
    }
  });

  $(document).on('mouseleave', '.sticky_add_to_bag', function (e) {
    $('.sticky_add_to_bag_color_swatch_product').hide();
    $('.sticky_add_to_bag_color_select svg').removeClass('rotate180');

    $('.sticky_add_to_bag_product_variant').hide();
    $('.sticky_add_to_bag_size_select svg').removeClass('rotate180');

    $('.sticky_add_to_bag').removeClass('sticky_add_to_bag_select_open');
    $('body').removeClass('sticky_add_to_bag_select_open');
  });

  $(document).on('click', '.sticky_add_to_bag_product_variant div[data-sizevalue]', function (e) {
    e.preventDefault();

    if (!$('.sticky_add_to_bag .product-form__submit').prop('disabled')) {
      $('.active_size').removeClass('active_size');
      $(this).addClass('active_size');
      $('.sticky_add_to_bag_size_select span').html('<b>Size</b> '+$(this).text());
      $('.sticky_add_to_bag .product-form__submit').attr('data-sizevalue', $(this).attr('data-sizevalue'));
      $('.sticky_add_to_bag .product-form__submit span > span').text('Add to bag');
      $('.sticky_add_to_bag').removeClass('sticky_add_to_bag_select_open');
      $('body').removeClass('sticky_add_to_bag_select_open');
      $('.sticky_add_to_bag_size_select svg').removeClass('rotate180');
      $('.sticky_add_to_bag_product_variant').hide();
    }
  });

  $(document).on('click', '.sticky_add_to_bag .product-form__submit', function (e) {
    e.preventDefault();

    if ($(this).attr('data-sizevalue') != undefined) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {id: $(this).attr('data-sizevalue'), quantity: 1},
        success: function(cart) {
            console.log(cart);  
            return;
        }
      });
    } else {
      alert('Please select a size');
    }
  });

  // $.ajax({
  //     url: 'https://reviews.lvwstore.com/get_reviews.php?code=reviews_jhbegf6ygyi878huweyub7v228bfbv72yh',
  //     type: 'POST',
  //     data: {
  //         exportAll: true,
  //     },
  //     dataType: 'json',
  //     success: function(data) {
  //         console.error(data);
  //     }
  // });

  $('.size_chart_table .centimeters').hide();
  $('.size_guide_toggle input').on('change', function() {
      if ($(this).is(":checked")) {
          $('.size_guide_toggle input').prop('checked', true);
          $('.size_chart_table .centimeters').show();
          $('.size_chart_table .inches').hide();
      } else {
          $('.size_guide_toggle input').prop('checked', false);
          $('.size_chart_table .centimeters').hide();
          $('.size_chart_table .inches').show();
      }
  });

  enableSwipe(document, true); // true means mousewheel/trackpad too. It's the default.
  $(".bordered_collection").on({
      swipeleft: function() {
        if ($(this).parents('.myAccountTabs').length) {
          var currentElement = $(this).parents('.myAccountTabs');
        } else {
          var currentElement = $(this).parents('.nickyTabs');
        }
        // volgende
        var totalCount = $('.collection-list li', currentElement).length;
        var currentTab = $('.collection-list li.active', currentElement).attr('data-tabindex');
        var nextTab = parseInt(parseInt(currentTab) + 1);

        if (nextTab <= totalCount) {
          $('.truncated', currentElement).show();
          $('.fullDescription', currentElement).hide();

          $('.collection-list li.active', currentElement).removeClass('active');
          $('.collection-list li[data-tabindex="'+nextTab+'"]', currentElement).addClass('active');

          $('.collection-list li[data-tabindex="'+nextTab+'"]', currentElement).parents('scrollable-content').animate({scrollLeft: $('.collection-list li[data-tabindex="'+nextTab+'"]', currentElement).position().left - 15}, 500);

          $('.tab-content > div', currentElement).hide();
          $('.tab-content .tab-content-'+$('.collection-list li[data-tabindex="'+nextTab+'"]', currentElement).attr('data-tabindex'), currentElement).show();
        }

      },
      swiperight: function() {
        if ($(this).parents('.myAccountTabs').length) {
          var currentElement = $(this).parents('.myAccountTabs');
        } else {
          var currentElement = $(this).parents('.nickyTabs');
        }
        // vorige
        var currentTab = $('.collection-list li.active', currentElement).attr('data-tabindex');
        var prevTab = parseInt(parseInt(currentTab) - 1);
        if (prevTab >= 1) {
          $('.truncated', currentElement).show();
          $('.fullDescription', currentElement).hide();

          $('.collection-list li.active', currentElement).removeClass('active');
          $('.collection-list li[data-tabindex="'+prevTab+'"]', currentElement).addClass('active');

          $('.collection-list li[data-tabindex="'+prevTab+'"]', currentElement).parents('scrollable-content').animate({scrollLeft: $('.collection-list li[data-tabindex="'+prevTab+'"]', currentElement).position().left - 15}, 500);

          $('.tab-content > div', currentElement).hide();
          $('.tab-content .tab-content-'+$('.collection-list li[data-tabindex="'+prevTab+'"]', currentElement).attr('data-tabindex'), currentElement).show();
        }
      },
  });

  if ($('.collection-list').length) {
    $('.collection-list li').removeClass('active');
    $('.collection-list li.tab-header-1').addClass('active');

    $('.tab-content > div').hide();
    $('.tab-content .tab-content-1').show();

    $('.collection-list li').on('click', function() {
      if ($(this).parents('.myAccountTabs').length) {
        var currentElement = $(this).parents('.myAccountTabs');
      } else {
        var currentElement = $(this).parents('.nickyTabs');
      }

      $('.collection-list li', currentElement).removeClass('active');
      $(this).addClass('active');

      $(this).parents('scrollable-content').animate({scrollLeft: $(this).position().left - 15}, 500);

      $('.truncated', currentElement).show();
      $('.fullDescription', currentElement).hide();

      $('.tab-content > div', currentElement).hide();
      $('.tab-content .tab-content-'+$(this).attr('data-tabindex'), currentElement).show();
    });
  }

  if (localStorage.getItem('product_grid_view_option') && localStorage.getItem('product_grid_view_option') != undefined && localStorage.getItem('product_grid_view_option') != '') {
    if (localStorage.getItem('product_grid_view_option') == 1) {
      $('.product_overview_view_option_1').addClass('active');
      $('.product_overview_view_option_2').removeClass('active');
      $('.product_overview_view_option_3').removeClass('active');

      $('#product-grid').addClass('display_1_items_per_row');
    } else if (localStorage.getItem('product_grid_view_option') == 2) {
      $('.product_overview_view_option_1').addClass('active');
      $('.product_overview_view_option_2').addClass('active');
      $('.product_overview_view_option_3').removeClass('active');

      $('#product-grid').addClass('display_2_items_per_row');
    } else if (localStorage.getItem('product_grid_view_option') == 3) {
      $('.product_overview_view_option_1').addClass('active');
      $('.product_overview_view_option_2').addClass('active');
      $('.product_overview_view_option_3').addClass('active');

      $('#product-grid').addClass('display_3_items_per_row');
    }
  } else {
    $('.product_overview_view_option_1').addClass('active');
    $('.product_overview_view_option_2').addClass('active');
    $('.product_overview_view_option_3').removeClass('active');

    $('#product-grid').addClass('display_2_items_per_row');
  }

  if (localStorage.getItem('display_model_images') && localStorage.getItem('display_model_images') != undefined && localStorage.getItem('display_model_images') != '') {
    if (localStorage.getItem('display_model_images') == 'true') {
      $('.product_overview_model_switch').addClass('active');
  
      $('#product-grid').addClass('display_model_images');
    } else {
      $('.product_overview_model_switch').removeClass('active');
  
      $('#product-grid').removeClass('display_model_images');
    }
  } else {
    $('.product_overview_model_switch').removeClass('active');

    $('#product-grid').removeClass('display_model_images');
  }

  $('.product_overview_view_options').on('click', function(e) {

    if ($('.product_overview_view_option_1').hasClass('active') && $('.product_overview_view_option_2').hasClass('active') && $('.product_overview_view_option_3').hasClass('active')) {
      $('.product_overview_view_option_2').removeClass('active');
      $('.product_overview_view_option_3').removeClass('active');

      $('#product-grid').removeClass('display_3_items_per_row');
      $('#product-grid').removeClass('display_2_items_per_row');

      $('#product-grid').addClass('display_1_items_per_row');

      localStorage.setItem('product_grid_view_option', '1');
    } else if ($('.product_overview_view_option_1').hasClass('active') && $('.product_overview_view_option_2').hasClass('active')) {
      $('.product_overview_view_option_3').addClass('active');

      $('#product-grid').removeClass('display_1_items_per_row');
      $('#product-grid').removeClass('display_2_items_per_row');

      $('#product-grid').addClass('display_3_items_per_row');

      localStorage.setItem('product_grid_view_option', '3');
    } else if ($('.product_overview_view_option_1').hasClass('active')) {
      $('.product_overview_view_option_2').addClass('active');

      $('#product-grid').removeClass('display_1_items_per_row');
      $('#product-grid').removeClass('display_3_items_per_row');

      $('#product-grid').addClass('display_2_items_per_row');

      localStorage.setItem('product_grid_view_option', '2');
    }
  });

  $('.product_overview_model_options').on('click', function(e) {
    if ($('.product_overview_model_switch').hasClass('active')) {
      $('.product_overview_model_switch').removeClass('active');

      $('#product-grid').removeClass('display_model_images');

      localStorage.setItem('display_model_images', 'false');
    } else {
      $('.product_overview_model_switch').addClass('active');

      $('#product-grid').addClass('display_model_images');

      localStorage.setItem('display_model_images', 'true');
    }
  });

  $(document).on('click', '[data-link]', function (e) {
    e.preventDefault();

    var link = $(this).attr('data-link');
    if (window.Shopify.locale == 'nl' && $(this).attr('data-dutchlink') != undefined) {
      var link = $(this).attr('data-dutchlink');
    }

    window.location.href = link;
  });

  $('.close_menu').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    console.log('close_menu CLICK');

    $(this).parents('sticky-header').find('summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset').click();
  });

  $(document).on('click', '.shop_the_look_product', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('.shop_the_look_product').find('.shop_the_look_variants').removeClass('show');
    if ($(this).find('.shop_the_look_variants').hasClass('show')) {
      $(this).find('.shop_the_look_variants').removeClass('show');
    } else {
      $(this).find('.shop_the_look_variants').addClass('show');
    }
  });

  $(document).on('mouseleave', '.shop_the_look_product', function (e) {
    $('.shop_the_look_product').find('.shop_the_look_variants').removeClass('show');
  });

  $(document).on('click', '.shop_the_look_products_holder .shop_the_look_product_image .shop_the_look_variant:not(".disabled")', function (e) {
    e.preventDefault();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {id: $(this).attr('data-variant_id'), quantity: 1, properties: {stl: 'Shop the look product'}},
      success: function(cart) {
          console.log(cart);
          return;
      }
    });
  });

  $('#navigation_tabs li a:not(:first)').addClass('inactive');
  $('.tab-content-container').hide();
  $('.tab-content-container:first').show();

  $('#navigation_tabs li a').click(function(){
    var t = $(this).attr('id');
  
    if($(this).hasClass('inactive')){ //this is the start of our condition 
      $('#navigation_tabs li a').addClass('inactive');           
      $(this).removeClass('inactive');
  
      $('.tab-content-container').hide();
      $('#'+ t + 'Content').fadeIn('slow');
   }
  });

  // $('.sticky_add_to_bag .product-form__submit').on('click', function(e) {
  //   e.preventDefault();

  //   alert('Please select a size');
  // });

  $('.product__accordion').on('click', function(e) {
    if ($('details', this).attr('open') == undefined || $('details', this).attr('open') == false) {
      $(this).addClass('product__accordion_clicked');
  
      $('.product__accordion:not(.product__accordion_clicked) details').removeAttr('open');
      $('.product__accordion:not(.product__accordion_clicked) summary').removeAttr('aria-expanded');
  
      $(this).removeClass('product__accordion_clicked');
  
      $('html, body').animate({ scrollTop: $(this).offset().top - $('sticky-header').height() }, 500);
    }
  });

  $('footer .accordion').on('click', function(e) {
    if ($('details', this).attr('open') == undefined || $('details', this).attr('open') == false) {
      $(this).addClass('footer_accordion_clicked');

      $('footer .accordion:not(.footer_accordion_clicked) details').removeAttr('open');
      $('footer .accordion:not(.footer_accordion_clicked) summary').removeAttr('aria-expanded');

      $(this).removeClass('footer_accordion_clicked');
    }
  });

  $('.average_product_rating_link').on('click', function(e) {
    e.preventDefault();

    $('html, body').animate({ scrollTop: $('#judgeme_product_reviews').offset().top - $(window).height() / 4 }, 500);
  });

  $(document).on('click', '.overview_quick_add', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $(this).parents('.product-card-wrapper').find('.quick-add__submit').click();
  });

  
  $.ajax({
    url: 'https://reviews.lvwstore.com/get_reviews.php?code=reviews_jhbegf6ygyi878huweyub7v228bfbv72yh',
    type: 'POST',
    data: {
        exportAll: true,
    },
    dataType: 'json',
    success: function(data) {

        if (data) {
          console.log(data);

          if ($('.product-card-wrapper').length) {
            $('.product-card-wrapper').each(function(i, obj) {
                var data_handle = $(obj).attr('data-handle');
  
                if (data[data_handle] != undefined) {
                  $('.overview_review_holder', obj).html('<a href="javascript:void" class="average_product_rating_link" style="display: none;"><span class="average_product_rating" data-rating="'+data[data_handle].average+'"></span><span>('+data[data_handle].total_reviews+')</span></a>');
                  $('.average_product_rating_link', obj).show();
                  var average_product_rating_width = $('.average_product_rating', obj).width();
                  var average_product_rating_stars = $('.average_product_rating', obj).attr('data-rating');
                  $('.average_product_rating', obj).width(Math.round(average_product_rating_width * (average_product_rating_stars / 5)));
                }
            });
          }

          if ($('.featured-collection-special').length) {
            $('.featured-collection-special').each(function(i, obj) {
              var data_handle = $(obj).attr('data-handle');

              if (data_handle != undefined) { // Nederlands fix
                if (data_handle == 'signature-collectie') data_handle = 'signature';
                if (data_handle == 'skin-collectie') data_handle = 'skin';
                if (data_handle == 'essentials-collectie') data_handle = 'essentials';
                if (data_handle == 'premium-collectie') data_handle = 'premium';
                if (data_handle == 'gold-collectie') data_handle = 'gold';
              }

              if (data[data_handle] != undefined) {
                $('.collection__title .overview_review_holder', obj).html('<a href="javascript:void" class="average_product_rating_link" style="display: none;"><span class="average_product_rating" data-rating="'+data[data_handle].average+'"></span><span>('+data[data_handle].total_reviews+')</span></a>');
                $('.collection__title .average_product_rating_link', obj).show();
                var average_product_rating_width = $('.collection__title .average_product_rating', obj).width();
                var average_product_rating_stars = $('.collection__title .average_product_rating', obj).attr('data-rating');
                $('.collection__title .average_product_rating', obj).width(Math.round(average_product_rating_width * (average_product_rating_stars / 5)));
              }
            });
          }

          if ($('.general_reviews').length) {
            // console.warn('append complete');

            // var reviews_counter = 0;
            for (let index = data['WEBSITE'].reviews.length - 1; index >= 0; index--) {
              // if (reviews_counter == 10) break;

              var review = data['WEBSITE'].reviews[index];
              if (review.highlighted) $('.general_reviews .review_slider').append('<li class="review_slider_review_item"><h5 class="review_name">'+review.name.split(" ")[0]+'<span class="review_verified_buyer_badge"><i class="fa-solid fa-circle-check"></i> Verfied buyer</span></h5><div class="review_stars" data-rating="'+review.rating+'"><i class="'+((review.rating >= 1) ? 'fa-solid fa-star' : (review.rating >= 0.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating >= 2) ? 'fa-solid fa-star' : (review.rating >= 1.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating >= 3) ? 'fa-solid fa-star' : (review.rating >= 2.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating >= 4) ? 'fa-solid fa-star' : (review.rating >= 3.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating == 5) ? 'fa-solid fa-star' : (review.rating >= 4.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i></div><h5 class="review_title">'+review.title+'</h5><p class="review_text">'+review.review+'</p><h6 class="review_date">'+review.date+'</h6></li>');

              // reviews_counter++;
            }

            $('.review_text').truncate({
                length: 200,
                minTrail: 10,
                moreText: 'Show more',
                lessText: 'Show less'
            });  
          }

          
          if ($('.general_reviews_page').length) {
            var reviews_counter = 0;
            var reviews_pages = 1;
            var appendable_div = 'general_reviews_page .reviews_holder';
            for (let index = data['WEBSITE'].reviews.length - 1; index >= 0; index--) {
                var review = data['WEBSITE'].reviews[index];
                if (reviews_counter != 0 && reviews_counter % 3 === 0) {
                    $('.general_reviews_page .reviews_holder').append('<div class="general_reviews_page_'+reviews_pages+'" style="display: none;"></div>');
                    appendable_div = 'general_reviews_page .general_reviews_page_'+reviews_pages;
                    reviews_pages++;
                }
                $('.'+appendable_div).append('<div class="review_slider_review_item"><h5 class="review_name">'+review.name.split(" ")[0]+'<span class="review_verified_buyer_badge"><i class="fa-solid fa-circle-check"></i> Verfied buyer</span></h5><div class="review_stars" data-rating="'+review.rating+'"><i class="'+((review.rating >= 1) ? 'fa-solid fa-star' : (review.rating >= 0.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating >= 2) ? 'fa-solid fa-star' : (review.rating >= 1.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating >= 3) ? 'fa-solid fa-star' : (review.rating >= 2.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating >= 4) ? 'fa-solid fa-star' : (review.rating >= 3.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((review.rating == 5) ? 'fa-solid fa-star' : (review.rating >= 4.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i></div><h5 class="review_title">'+review.title+'</h5><p class="review_text">'+review.review+'</p><h6 class="review_date">'+review.date+'</h6></div>');
                reviews_counter++;
            }
            if (reviews_pages > 1) {
                $('.general_reviews_page .reviews_holder').append('<button class="load_more_reviews" data-reviewpage="1">Load more reviews</button>');
            }

            $('.review_text').truncate({
                length: 200,
                minTrail: 10,
                moreText: 'Show more',
                lessText: 'Show less'
            });

            $('.general_reviews_text_average_holder').append('<p class="general_reviews_average_text">'+data['WEBSITE'].average+'</p><p class="general_reviews_average_subtext"><i class="'+((data['WEBSITE'].average >= 1) ? 'fa-solid fa-star' : (data['WEBSITE'].average >= 0.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((data['WEBSITE'].average >= 2) ? 'fa-solid fa-star' : (data['WEBSITE'].average >= 1.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((data['WEBSITE'].average >= 3) ? 'fa-solid fa-star' : (data['WEBSITE'].average >= 2.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((data['WEBSITE'].average >= 4) ? 'fa-solid fa-star' : (data['WEBSITE'].average >= 3.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><i class="'+((data['WEBSITE'].average == 5) ? 'fa-solid fa-star' : (data['WEBSITE'].average >= 4.5) ? 'fa-solid fa-star-half-stroke' : 'fa-regular fa-star')+'"></i><br>Based on '+data['WEBSITE'].total_reviews+' reviews</p>');
          }
        }

    }
  });
  

  $(document).on('click', '.load_more_reviews', function (e) {
    e.preventDefault();

    var reviewpage = $(this).attr('data-reviewpage');
    if ($('.product_reviews_page_'+reviewpage).length) {
      $(this).text('Load more reviews');
      $('.product_reviews_page_'+reviewpage).show();
      $(this).attr('data-reviewpage', parseInt(parseInt($(this).attr('data-reviewpage')) + 1));

      if ($('.product_reviews_page_'+parseInt(parseInt(reviewpage) + 1)).length) {
      } else {
        $(this).hide();
      }
    } else if ($('.general_reviews_page_'+reviewpage).length) {
      $(this).text('Load more reviews');
      $('.general_reviews_page_'+reviewpage).show();
      $(this).attr('data-reviewpage', parseInt(parseInt($(this).attr('data-reviewpage')) + 1));

      if ($('.general_reviews_page_'+parseInt(parseInt(reviewpage) + 1)).length) {
      } else {
        $(this).hide();
      }
    }
  });
});

$(window).on('resize scroll', function() {
    // if ($('.product-form__buttons .product-form__submit').length) {
    //   if ($('.product-form__buttons .product-form__submit').isInViewport()) {
    //       $('.sticky_add_to_bag').fadeOut(500);
    //   } else {
    //       $('.sticky_add_to_bag').fadeIn(500);
    //   }
    // }

    if ($('.general_reviews').length) {
      if ($('.general_reviews').isInViewport()) {
          $('.sticky_add_to_bag').addClass('hidden');
      } else if ($('.product_other_products').length) {
          if ($('.product_other_products').isInViewport()) {
              $('.sticky_add_to_bag').removeClass('hidden'); //.css('display', 'flex');
          }
      }
    }
});

$(window).on("load", function() {

    if ($('.slider-page-title_active').length) {
        $('.slider-page-title').animate({ scrollLeft: $('.slider-page-title_active').offset().left - $(window).width() / 4 }, 500);
    }

    setTimeout(hideLoader, 1000);

    if (window.location.pathname == '/collections/all' || window.location.pathname == '/nl/collections/all') {
      if (window.location.pathname == '/collections/all') {
        window.location.href = "/collections";
      }
      if (window.location.pathname == '/nl/collections/all') {
        window.location.href = "/nl/collections";
      }
    }

    // $('.average_product_rating_link').hide();

    setTimeout(createSwiper, 1000);

    if ($('.product__title h1').length && $('.product__title h1').attr('data-color') != undefined && $('.product__title h1').attr('data-color') != '') {
      var active_color = $('.product__title h1').attr('data-color');
      if (active_color == 'white') {
        active_color = 'brandy_snifter';
      }
      var active_color = colors[active_color];
      if (active_color == undefined) {
        active_color = colors['brandy_snifter'];
      }
      $("body").get(0).style.setProperty("--product-color", active_color);

      $.ajax({
        url: 'https://reviews.lvwstore.com/get_reviews.php?code=reviews_jhbegf6ygyi878huweyub7v228bfbv72yh',
        type: 'POST',
        data: {
            product: 'LVW '+$('.product__title h1').attr('data-producttitle'),
        },
        dataType: 'json',
        success: function(data) {
  
            if (data) {
              console.log(data);

              $('.average_product_rating_link').show();
  
              $('.average_product_rating_link span.average_product_rating').attr('data-rating', data.average);
              $('.average_product_rating_link span:not(.average_product_rating)').text(data.average+' ('+ data.total_reviews +')');
  
              var average_product_rating_width = $('.average_product_rating').width();
              var average_product_rating_stars = $('.average_product_rating').attr('data-rating');
              $('.average_product_rating').width(Math.round(average_product_rating_width * (average_product_rating_stars / 5)));

              $('#judgeme_product_reviews').append('<div class="product_reviews"></div>');

              setTimeout(function() {
                var widg__summary = '<div class="jdgm-rev-widg__summary"><div class="jdgm-rev-widg__summary-inner"><div class="jdgm-rev-widg__summary-stars" aria-label="Average rating is '+ data.average +' stars" role="img"><span class="jdgm-star jdgm--'+((data.average >= 1) ? 'on' : (data.average >= 0.5) ? 'half' : 'off')+'"></span><span class="jdgm-star jdgm--'+((data.average >= 2) ? 'on' : (data.average >= 1.5) ? 'half' : 'off')+'"></span><span class="jdgm-star jdgm--'+((data.average >= 3) ? 'on' : (data.average >= 2.5) ? 'half' : 'off')+'"></span><span class="jdgm-star jdgm--'+((data.average >= 4) ? 'on' : (data.average >= 3.5) ? 'half' : 'off')+'"></span><span class="jdgm-star jdgm--'+((data.average == 5) ? 'on' : (data.average >= 4.5) ? 'half' : 'off')+'"></span><span class="jdgm-rev-widg__summary-average">'+ data.average +' out of 5</span></div><div class="jdgm-rev-widg__summary-text">Based on '+ data.total_reviews +' reviews</div></div></div>';
                $('.jdgm-rev-widg__summary').replaceWith(widg__summary);
                var histogram = '<div class="jdgm-histogram jdgm-temp-hidden"><div class="jdgm-histogram__row" data-rating="5" data-frequency="'+((data.stars[5] != undefined) ? data.stars[5] : 0)+'" data-percentage="'+((data.stars['5_percentage'] != undefined) ? data.stars['5_percentage'] : 0)+'"><div class="jdgm-histogram__star" role="button" aria-label="'+((data.stars['5_percentage'] != undefined) ? data.stars['5_percentage'] : 0)+'% ('+((data.stars[5] != undefined) ? data.stars[5] : 0)+') reviews with 5 star rating" tabindex="0"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span></div><div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width: '+((data.stars['5_percentage'] != undefined) ? data.stars['5_percentage'] : 0)+'%;"></div></div><div class="jdgm-histogram__frequency">'+((data.stars[5] != undefined) ? data.stars[5] : 0)+'</div></div><div class="jdgm-histogram__row" data-rating="4" data-frequency="'+((data.stars[4] != undefined) ? data.stars[4] : 0)+'" data-percentage="'+((data.stars['4_percentage'] != undefined) ? data.stars['4_percentage'] : 0)+'"><div class="jdgm-histogram__star" role="button" aria-label="'+((data.stars['4_percentage'] != undefined) ? data.stars['4_percentage'] : 0)+'% ('+((data.stars[4] != undefined) ? data.stars[4] : 0)+') reviews with 4 star rating" tabindex="0"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--off"></span></div><div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width: '+((data.stars['4_percentage'] != undefined) ? data.stars['4_percentage'] : 0)+'%;"></div></div><div class="jdgm-histogram__frequency">'+((data.stars[4] != undefined) ? data.stars[4] : 0)+'</div></div><div class="jdgm-histogram__row" data-rating="3" data-frequency="'+((data.stars[3] != undefined) ? data.stars[3] : 0)+'" data-percentage="'+((data.stars['3_percentage'] != undefined) ? data.stars['3_percentage'] : 0)+'"><div class="jdgm-histogram__star" role="button" aria-label="'+((data.stars['3_percentage'] != undefined) ? data.stars['3_percentage'] : 0)+'% ('+((data.stars[3] != undefined) ? data.stars[3] : 0)+') reviews with 3 star rating" tabindex="0"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span></div><div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width: '+((data.stars['3_percentage'] != undefined) ? data.stars['3_percentage'] : 0)+'%;"></div></div><div class="jdgm-histogram__frequency">'+((data.stars[3] != undefined) ? data.stars[3] : 0)+'</div></div><div class="jdgm-histogram__row" data-rating="2" data-frequency="'+((data.stars[2] != undefined) ? data.stars[2] : 0)+'" data-percentage="'+((data.stars['2_percentage'] != undefined) ? data.stars['2_percentage'] : 0)+'"><div class="jdgm-histogram__star" role="button" aria-label="'+((data.stars['2_percentage'] != undefined) ? data.stars['2_percentage'] : 0)+'% ('+((data.stars[2] != undefined) ? data.stars[2] : 0)+') reviews with 2 star rating" tabindex="0"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span></div><div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width: '+((data.stars['2_percentage'] != undefined) ? data.stars['2_percentage'] : 0)+'%;"></div></div><div class="jdgm-histogram__frequency">'+((data.stars[2] != undefined) ? data.stars[2] : 0)+'</div></div><div class="jdgm-histogram__row" data-rating="1" data-frequency="'+((data.stars[1] != undefined) ? data.stars[1] : 0)+'" data-percentage="'+((data.stars['1_percentage'] != undefined) ? data.stars['1_percentage'] : 0)+'"><div class="jdgm-histogram__star" role="button" aria-label="'+((data.stars['1_percentage'] != undefined) ? data.stars['1_percentage'] : 0)+'% ('+((data.stars[1] != undefined) ? data.stars[1] : 0)+') reviews with 1 star rating" tabindex="0"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span></div><div class="jdgm-histogram__bar"><div class="jdgm-histogram__bar-content" style="width: '+((data.stars['1_percentage'] != undefined) ? data.stars['1_percentage'] : 0)+'%;"></div></div><div class="jdgm-histogram__frequency">'+((data.stars[1] != undefined) ? data.stars[1] : 0)+'</div></div><div class="jdgm-histogram__row jdgm-histogram__clear-filter" data-rating="null" tabindex="0">See all reviews</div></div>';
                $('.jdgm-histogram.jdgm-temp-hidden').replaceWith(histogram);
              }, 1000);

              if (data.reviews && data.reviews.length > 0) {
                var reviews_counter = 0;
                var reviews_pages = 1;
                var appendable_div = 'product_reviews';
                appendable_div = 'product_reviews_page_'+reviews_pages;
                $('.product_reviews').append('<div class="product_reviews_page_'+reviews_pages+'" style="display: none;"></div>');
                for (let index = data.reviews.length - 1; index >= 0; index--) {
                  var review = data.reviews[index];
                  if (reviews_counter != 0 && reviews_counter % 3 === 0) {
                    if (reviews_pages == 1) reviews_pages = 2;
                    $('.product_reviews').append('<div class="product_reviews_page_'+reviews_pages+'" style="display: none;"></div>');
                    appendable_div = 'product_reviews_page_'+reviews_pages;
                    reviews_pages++;
                  }
                  $('.'+appendable_div).append('<div class="product_review"><div class="product_review_header"><span class="product_review_name">'+review.name+'</span><span class="product_review_date">'+review.date+'</span></div><div class="product_review_rating" data-rating="'+review.rating+'"><span class="jdgm-star jdgm--'+((review.rating >= 1) ? 'on' : 'off')+'"></span><span class="jdgm-star jdgm--'+((review.rating >= 2) ? 'on' : 'off')+'"></span><span class="jdgm-star jdgm--'+((review.rating >= 3) ? 'on' : 'off')+'"></span><span class="jdgm-star jdgm--'+((review.rating >= 4) ? 'on' : 'off')+'"></span><span class="jdgm-star jdgm--'+((review.rating == 5) ? 'on' : 'off')+'"></span></div><span class="product_review_title">'+review.title+'</span><p class="product_review_review">'+decodeEntities(review.review)+'</p></div>');
                  reviews_counter++;
                }
                // if (reviews_pages > 1) {
                  $('.product_reviews').append('<button class="load_more_reviews" data-reviewpage="1">Show reviews</button>');
                // }
              }
            } else {
              $('.average_product_rating_link').hide();
            }
  
        }
      });
    }
});